import { render } from "./PrintReceipt.vue?vue&type=template&id=5d596814&scoped=true"
import script from "./PrintReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReceipt.vue?vue&type=script&lang=js"

import "./PrintReceipt.vue?vue&type=style&index=0&id=5d596814&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d596814"

export default script